<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center class="mb-4 px-4">
      <v-flex xs12>
        <div style="background-color: #ffffff; border-radius: 20px; box-shadow: 0 10px 40px -10px rgba(0,0,0,0.05); padding: 16px 12px; margin-top: 12px; border: 1px solid #f1f5f9;">
          <categorySlider />
          <subCategorySlider class="mt-2" />
        </div>
      </v-flex>
    </v-layout>
    <v-layout  class="expanel">
      <v-flex class="hidden-md-and-up">
         <div class="text-left hidden-md-and-up">
         <v-app-bar-nav-icon @click="navDialogue=true" class="hidden-md-and-up"></v-app-bar-nav-icon>
          <v-dialog v-model="navDialogue" max-width="500px" class="hidden-md-and-up">
          <v-layout wrap>
            <v-flex xs12>
              <v-card outlined class="pa-2">
                <v-layout wrap>
                  
                  <v-flex xs12 text-right>
                    <v-icon @click="navDialogue=false">mdi-close</v-icon>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
        <sideNav v-cloak v-bind:navItem="sidenavItems" :productList="productList" @stepper="winStepper" />

                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
         </v-dialog>
       </div>
      </v-flex>
      <v-flex :style="Draw ? 'width:20% ' : 'width:3% ' " style="transition:.5s" class="hidden-sm-and-down">
        <v-navigation-drawer>
        <div class="text-left">
         <v-app-bar-nav-icon @click="Draw =!Draw"></v-app-bar-nav-icon>
       </div>
      <div  v-if="Draw == true">
        <sideNav v-cloak v-bind:navItem="sidenavItems" :productList="productList" @stepper="winStepper" />
        </div>
       
        </v-navigation-drawer>
      </v-flex>
      <v-flex grow   :style="Draw ? 'width:80% ' : 'width:97% ' "  style="transition:.5s" >
        <!-- <v-layout wrap>
          <v-flex xs1 text-left>
            <v-select
              :items="filtertypes"
              v-model="filtertype"
              clearable hide-details
              label="Sort by:"
              dense
              class="select"
            ></v-select>
          </v-flex>
        </v-layout> -->
        <!-- <v-layout v-if="$route.query.subcategoryname == 'All' || !$route.query.subcategory" wrap>
          <v-flex xs12 v-for="(item1, i) in productList" :key="i">
            <v-layout wrap>
              <v-flex xs12> </v-flex>
            </v-layout>
          </v-flex>
        </v-layout> -->
        <!-- <v-layout
          wrap
          justify-start
          v-if="productList.length > 0 && $route.query.subcategory"
        > -->
        <v-layout wrap v-if="productList.length > 0" style="transition:.5s">
          <v-flex xs12 sm6 md4 lg3 xl2 pa-3 v-for="(item, i) in productList" :key="i" style="transition:.5s">
            <div id="container">
              <div
                id="infoi"
                v-if="
                  item.status == 'Inactive' ||
                  item.quantity < item.minimumOrderQuantity
                "
              >
                <img
                  src="./../../../assets/Images/outofstock1.png"
                  width="150"
                />
              </div>
            </div>
            <v-hover v-slot="{ hover }">
              <v-card
                class="premium-product-card mx-auto"
                :elevation="hover ? 12 : 0"
                style="transition:all .3s ease; border-radius: 16px; border: 1px solid #f1f5f9; overflow: hidden; display: flex; flex-direction: column; height: 100%;"
                @click="changeRoute(item)"
              >
                <!-- Image Section -->
                <div style="position: relative; background: white; padding: 16px; display: flex; justify-content: center; align-items: center; border-radius: 16px 16px 0 0; overflow: hidden;">
                  <!-- Stock Status -->
                  <div style="position: absolute; top: 12px; left: 12px; z-index: 2; display: flex; flex-direction: column; gap: 6px;">
                    <div v-if="item.status == 'Inactive' || item.quantity < item.minimumOrderQuantity" style="background: #fee2e2; color: #ef4444; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
                      Out of Stock
                    </div>
                  </div>
                  
                  <v-img
                    v-if="item.photos && item.photos.length > 0"
                    :src="mediaURL + item.photos[0]"
                    height="200"
                    contain
                    class="product-visual"
                    style="transition: transform 0.5s ease; cursor: pointer;"
                  >
                    <template v-slot:placeholder>
                      <div class="img-shimmer"></div>
                    </template>
                  </v-img>
                  <v-img
                    v-else
                    src="./../../../assets/Images/noimage.png"
                    height="200"
                    contain
                    class="product-visual"
                  ></v-img>
                </div>

                <!-- Info Section -->
                <v-card-text class="pa-4 text-left d-flex flex-column" style="flex-grow: 1;">
                  <!-- Category Tag with Leaf Icon -->
                  <!-- <div style="display: inline-flex; align-items: center; background: rgba(62, 165, 110, 0.08); padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; color: #3EA56E; margin-bottom: 12px; align-self: flex-start;">
                    <v-icon left size="14" color="#3EA56E">mdi-leaf</v-icon>
                    <span v-if="item.categoryId">{{ item.categoryId.name }}</span>
                    <span v-else>Product</span>
                  </div> -->

                  <!-- Title -->
                  <h3  style="  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 10px;

  width: 100%;
  display: block;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;">
                    {{ item.productname }}
                  </h3>

                  <!-- Rating -->
                  <div style="display: flex; align-items: center; margin-bottom: 8px;">
                    <v-rating v-model="item.rating" background-color="#E2E8F0" color="#F59E0B" dense readonly size="16" half-increments></v-rating>
                  </div>

                  <div style="flex-grow: 1;"></div>

                  <!-- Price -->
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px;">
                    <div style="font-size: 20px; font-weight: 700; color: #3EA56E;">
                      ₹{{ item.offerPrice || item.price }} 
                      <span v-if="item.unit" style="font-size: 13px; font-weight: 500; color: #64748b;">/ {{ item.unit }}</span>
                    </div>
                    <div v-if="item.price > item.offerPrice" style="font-size: 14px; color: #94a3b8; text-decoration: line-through;">
                      ₹{{ item.price }}
                    </div>
                  </div>

                  <!-- Actions -->
                  <div style="display: flex; gap: 12px; align-items: center; margin-top: auto;">
                    <v-btn 
                      v-if="!item.isincart"
                      depressed 
                      color="#3EA56E" 
                      dark 
                      style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                      @click.stop="addToCart(item._id)"
                      :disabled="item.status == 'Inactive' || item.quantity < item.minimumOrderQuantity"
                    >
                      <v-icon left size="20">mdi-cart-outline</v-icon>
                      Add to Cart
                    </v-btn>
                    
                    <v-btn 
                      v-if="item.isincart"
                      depressed 
                      color="#3EA56E" 
                      dark 
                      style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                      @click.stop="$router.push('/cart')"
                    >
                      <v-icon left size="20">mdi-check</v-icon>
                      In Cart
                    </v-btn>

                    <v-btn 
                      icon 
                      outlined 
                      :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#e2e8f0'" 
                      style="border: 1px solid #e2e8f0; border-radius: 8px; width: 40px; height: 40px;"
                      @click.stop="toggleWishlist(item)"
                    >
                      <v-icon size="20" :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#64748b'">{{ item.inWishlist || item.inwishlist ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-hover>
            <!-- <v-card tile outlined>
              <v-layout wrap justify-start>
                <v-flex xs12 pa-2 align-self-center v-if="item.productName">
                  {{ item.productName }} <br />
                  subcategory: {{ item.subcategoryId.name }} <br />
                  category: {{ item.categoryId.name }}
                </v-flex>
              </v-layout>
            </v-card> -->
          </v-flex>
        </v-layout>

        <v-layout wrap v-else align-center py-16>
          <v-flex xs12 align-self-center>
            <span>Currently no products available! </span>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 py-2>
            <v-pagination
              v-if="productList.length > 0"
              small
              color="#3EA56E"
              total-visible="7"
              v-model="page" 
              :length="Pagelength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import categorySlider from "./CategorySlider";
import subCategorySlider from "./subCategorySlider";
import sideNav from "./sideNav";

// import { VueEditor } from "vue2-editor";
export default {
  components: {
    categorySlider,
    subCategorySlider,
    sideNav,
    // VueEditor,
  },
  data() {
    return {
      navDialogue: false,
      Draw:true,
      transparent: "rgba(255, 255, 255, 0)",
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      msg: null,
      mainCategoryId: null,
      timeout: 5000,
      productList: [],
      allproductList: [],
      sidenavItems: {
        inStock: null,
        outOffstock: null,
      },
      filtertypes: [
        "Price, low to high",
        "Price, high to low",
        "Alphabetically A-Z",
        "Alphabetically Z-A",
      ],
      page: 1,
      Pagelength: 0,
      limit: 50,
      filtertype: null,
      category: null,
      mainCategory: null,
      subCategory: null,
      inStock: false,
      outofstock: false,
      lowestPrice: null,
      highestPrice: null,
      keyword:null,
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    mainCat() {
      return this.$store.state.SelectedIDS.MainCatId;
    },
    getCat() {
      return this.$store.state.SelectedIDS.CatId;
    },
    getSubCat() {
      return this.$store.state.SelectedIDS.SubId;
    },
  },
  beforeMount() {
    this.productList = this.$store.state.searchResults;
    this.sidenavItems.inStock = this.$store.state.instock;
    this.sidenavItems.outOffstock = this.$store.state.outstock;
    console.log("from Store=", this.productList);
    this.mainCategory = this.mainCat;
    this.category = this.getCat;
    // if(this.category=='undefined'){
    //     this.category = ""
    //   }
    this.subCategory = this.getSubCat;
  },

  mounted() {
    console.log(this.$route.path);

    if (
      this.$route.params.MainCategory ||
      this.$route.query.Category ||
      this.$route.query.SubCategory ||
      this.$route.query.Spices 
    ) {
      this.getData();

    }
  },

  watch: {
    page() {
        this.getData();
    },
    '$store.state.searchResults': function(newVal) {
        if (this.$route.query.type === "'search'" || this.$route.query.type === "search") {
            this.productList = newVal;
            this.setMetaTags();
        }
    },
    '$store.state.instock': function(newVal) {
        if (this.$route.query.type === "'search'" || this.$route.query.type === "search") {
            this.sidenavItems.inStock = newVal;
        }
    },
    '$store.state.outstock': function(newVal) {
        if (this.$route.query.type === "'search'" || this.$route.query.type === "search") {
            this.sidenavItems.outOffstock = newVal;
        }
    }
  },
  methods: {
    setMetaTags() {
      let pageTitle = "Products | KL-06 FARM";
      let description = "Browse our wide selection of fresh fruits, premium spices, and beautiful plants at KL-06 FARM.";
      const searchKeyword = this.$route.query.q || this.keyword;

      if (this.$route.params.MainCategory) {
        pageTitle = this.$route.params.MainCategory + " | KL-06 FARM";
        description = "Buy fresh " + this.$route.params.MainCategory + " online from KL-06 FARM.";
      } else if (this.$route.query.Category) {
        pageTitle = this.$route.query.Category + " | KL-06 FARM";
        description = "Buy fresh " + this.$route.query.Category + " online from KL-06 FARM.";
      } else if (searchKeyword) {
        pageTitle = "Search Results for " + searchKeyword + " | KL-06 FARM";
        description = "Search results for " + searchKeyword + " at KL-06 FARM.";
      }

      document.title = pageTitle;
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    winStepper(item) {
      if (item.ref == "availability") {
        this.inStock = item.instock;
        this.outofstock = item.outstock;
        this.lowestPrice = item.lowest;
        this.highestPrice = item.highest;
        if (item.getdata == true) {
          this.getData();
        }
      }
       if (item.ref == "search") {
        this.keyword = item.keyword1;
        if (item.searchFun == true) {
          this.getData();
        }
      }
    },
     searchProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/search",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          keyword: this.keyword,
          page: this.page,
          limit: this.limit,
          // filterType: "today",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$store.commit("getSearchResults", response.data.data);
            this.productList = response.data.data;
            this.setMetaTags();
            this.$router.push(`/products?type='search'&q=${encodeURIComponent(this.keyword || '')}`).catch(()=>{});
            // setTimeout(() => { this.$router.push("/products") }, 1000);

            // this.$route.push()
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    changeRoute(item) {
      localStorage.setItem("productId", item._id);
      this.$router.push("/productdetailview/" + item.urlname);
    },

    getData() {
      this.productList = [];
      this.appLoading = true;
        var headers1 = {};
      var data = {
        maincategoryname: this.$route.params.MainCategory,
          availability: "1",
          instock: this.inStock,
          outstock: this.outofstock,
          lowerprice: this.lowestPrice,
          upperprice: this.highestPrice,
          keyword: this.keyword,
          categoryname: this.$route.query.Category,
          subcategoryname: this.$route.query.SubCategory,
          page: this.page,
          limit: this.limit,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "post",
        url: "/product/list",
       data: data,
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.productList = response.data.product;
            this.sidenavItems.outOffstock = response.data.outOffstock;
            this.sidenavItems.inStock = response.data.inStock;
            this.Pagelength = Math.ceil(response.data.totalLength / this.limit);
            this.setMetaTags();
          }

          // this.allproductList = JSON.parse(
          //   JSON.stringify(response.data.product)
          // );
          // if (!this.$route.query.subcategory) {
          //   var subidarr=[]
          //   this.allproductList = this.allproductList.map((x) => {
          //       // creating subcategory arrays
          //     if (!subidarr.includes(x.subcategoryId._id)) {
          //       subidarr.push(x.subcategoryId._id)
          //     }
          //     return x
          //   //   we return x not to create empty arrays wen same array repeat
          //   });
          //   console.log("Sub=", subidarr);
          //   var grouped = [];
          //   // grouping data to each sub array created
          //   for (let j = 0; j < subidarr.length; j++) {
          //     grouped[j] = {};
          //     grouped[j].subid = subidarr[j];
          //     grouped[j].arr = [];
          //     for (let i = 0; i < this.allproductList.length; i++) {
          //       if (subidarr[j] == this.allproductList[i].subcategoryId._id) {
          //         grouped[j].subname =
          //           this.allproductList[i].subcategoryId.name;
          //         grouped[j].arr.push(this.allproductList[i]);
          //       }
          //     }
          //   }
          //   console.log("grouped=", grouped);
          // }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addToCart(item) {
       var headers1 = {};
      var data = {
          productId: item,
          quantity: 1,
      };
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else data["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "post",
        url: "/cart/add",
       data: data,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.$store.commit("changeCart", response.data.cartLength);
            // this.$router.push("/cart");
            // setTimeout(() => this.$router.go(), 3000);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            // if (this.snackbar == false) {
            //   this.$router.go();
            // }
            // setTimeout(() => this.$router.go(), 3000);
          }
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleWishlist(item) {
      const inWishlist = item.inWishlist || item.inwishlist;
      const url = inWishlist ? "/WishList/Remove" : "/WishList/Addorupdate";

      var headers1 = {};
      var data = {
        productid: item._id
      };

      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: url,
        data: data,
        headers: headers1,
      })
      .then((response) => {
        if (response.data.status) {
          this.$set(item, 'inWishlist', !inWishlist);
          this.$set(item, 'inwishlist', !inWishlist);
          this.$store.commit("changeWishlist", response.data.wishlistcount);
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
<style scoped>
/* .v-select{ */

/* height:32px !important; */

/* max-height: 20px !important;
  min-height: 20px !important; */
/* height: 20px !important; */
/* color: red !important; */
/* } */
/* .v-text-field.v-text-field--enclosed .v-text-field__details, 
.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot .v-select__selections{
        margin: 0;
        max-height: 22px;
        min-height: 22px !important;
       display: flex!important;
       align-items: center!important
} */

.v-card {
  transition: opacity 0.4s ease-in-out;
}

/* Shimmer skeleton loader for product images */
.img-shimmer {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* .v-card:on-hover {
  opacity: 0.6;
} */

.show-btns {
  color: #3ea56e !important;
}
/* outofstock */
#container {
  position: relative;
}
#navi,
#infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
#infoi {
  z-index: 10;
}
.expanel
{
  display: flex !important;
  /* z-index: 1; */
}
.expanel2
{
  display: block !important;
  /* z-index: 1; */
}
</style>